<template>
  <div class="video">
    <div class="videoPlay" ref="playBox">
      <video id="myPlayer" controls playsInline webkit-playsinline autoplay>
        <source :src="videoUrl" type="application/x-mpegURL" />
      </video>
      <!-- <LivePlayer
        ref="player"
        :style="videoFull"
        :poster="img"
        :videoUrl="videoUrl"
        fluent
        live
        autoplay
        stretch
        :show-custom-button="false"
        webkit-playsinline="true"
        playsinline="true"
        x5-video-player-type="h5"
      >
      </LivePlayer> -->
      <div
        class="loading"
        :style="{ backgroundImage: 'url(' + img + ')' }"
        v-if="load"
      >
        <div class="loadImg"></div>
      </div>
      <div
        class="videoControl"
        :class="fullFlag ? 'changeBg' : ''"
        ref="bar"
        :style="barFull"
      >
        <div class="play" :class="playFlag ? '' : 'pause'" @click="play"></div>
        <div
          class="controlButton"
          :class="controlFlag ? 'controlSelsct' : ''"
          v-if="SD == 'SD'"
          @click="controlButton"
        ></div>
        <!-- <div class="definition" @click="definitionButton">
          {{ definition }}
          <div class="select" v-if="definitionFlag">
            <div
              class="option"
              :class="rtsp == '0' ? 'selectOption' : ''"
              @click="cut(0)"
            >
              高清
            </div>
            <div
              class="option"
              :class="rtsp == '1' ? 'selectOption' : ''"
              @click="cut(1)"
            >
              标清
            </div>
          </div>
        </div> -->
        <!-- <div class="voice" :class="muteFlag ?'voice1':''" @click="mutedActive"></div> -->
        <div
          class="fullScreen"
          :class="fullFlag ? 'full2' : ''"
          @click="goBack"
        ></div>
      </div>
    </div>
    <!-- <div class="control" v-if="controlButtonFlag">
      <div class="scale">
        <div
          class="zoomOut"
          :class="zoom == '2' ? 'zooms' : ''"
          @click="controlDirection('zoomDec')"
        >
          -
        </div>
        <div
          class="zoomIn"
          :class="zoom == '1' ? 'zooms' : ''"
          @click="controlDirection('zoomAdd')"
        >
          +
        </div>
      </div>
      <div class="bgcBox">
        <div class="bgc" :class="bgc">
          <div class="top" @click="controlDirection('up')" v-show="flag"></div>
          <div
            class="right"
            @click="controlDirection('right')"
            v-show="flag"
          ></div>
          <div
            class="bottom"
            @click="controlDirection('down')"
            v-show="flag"
          ></div>
          <div
            class="left"
            @click="controlDirection('left')"
            v-show="flag"
          ></div>
        </div>
      </div>
    </div> -->
    <div class="controlMax">
      <div class="bgcBox">
        <div class="bgc" :class="bgc">
          <div
            class="top"
            @touchstart="controlDirection(0)"
            @touchend="stopDirection"
          ></div>
          <div
            class="right"
            @touchstart="controlDirection(3)"
            @touchend="stopDirection"
          ></div>
          <div
            class="bottom"
            @touchstart="controlDirection(1)"
            @touchend="stopDirection"
          ></div>
          <div
            class="left"
            @touchstart="controlDirection(2)"
            @touchend="stopDirection"
          ></div>
          <div class="center" @click="getcontrolEnd"></div>
        </div>
      </div>
      <div class="scale">
        <div
          class="zoomOut"
          :class="zoom == '2' ? 'zooms' : ''"
          @click="controlDirection('zoomDec')"
        >
          -
        </div>
        <div
          class="zoomIn"
          :class="zoom == '1' ? 'zooms' : ''"
          @click="controlDirection('zoomAdd')"
        >
          +
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mix from "./video_index";
import EasyPlayer from "@easydarwin/easyplayer";
import LivePlayer from "@liveqing/liveplayer";
export default {
  mixins: [mix],
  components: {
    EasyPlayer,
    LivePlayer
  }
};
</script>
<style lang="less" scoped>
@import "./video.less";
</style>



// WEBPACK FOOTER //
// src/view/video/video.vue